export const minColumnWidth = 10;
export const totalPriceColumnWidth = 30;
